module.exports = __webpack_public_path__ + "static/media/proyectos.41529c50.webp";